import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import {
  updateFormData,
  nextStep,
  prevStep,
  
} from "../../redux/formSlice";
import {
  Box,

  Typography,
} from "@mui/material";

import BlackWhite from "../../components/icons/BlackWhite";
import Color from "../../components/icons/Color";
import OneSide from "../../components/icons/OneSide";
import TwoSide from "../../components/icons/TwoSide";
import { useTranslation } from "react-i18next";
import StepNavigation from "../../components/StepNavigation";

function Setting() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {  handleSubmit } = useForm();
  const formData = useSelector((state) => state.form.formData);
  const [settingsSaved, setSettingsSaved] = useState(false); // State to track if settings are saved

  const [selectedStatus, setSelectedStatus] = useState(formData.status); // Track selected status
  const [selectedType, setSelectedType] = useState(formData.type); // Track selected type

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  // API call to save the settings

  const onSubmit = (data) => {
    // Dispatch form data and save settings
    dispatch(
      updateFormData({ ...data, status: selectedStatus, type: selectedType })
    );

    setSettingsSaved(true); // Mark settings as saved
    dispatch(nextStep());
    dispatch(
      updateFormData({ ...data, status: selectedStatus, type: selectedType })
    );
    // Proceed to the next step
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
        marginBottom: "3.5rem",
      }}
    >
      <Box sx={{ mb: 2, width:"100%" }}>
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 ,  }}>        
          <Typography variant="h6" fontWeight={600}>{t("Upload.Printtype")}</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 , justifyContent:"space-between" }}>
          <Box
            sx={{
              flex: 1,

              p: 2,
              border: 2,
              borderColor: selectedType === "1" ? 'primary.main' : 'grey.300',
              bgcolor: selectedType === "1" ? 'secondary.main'  : 'background.paper',
              color: selectedType === "1" ? 'white' : 'text.primary',
              borderRadius: 2,
              cursor: 'pointer',
              boxShadow: selectedType === "1" ? 2 : 0,
             
            }}
            onClick={() => {
              setSelectedType("1");
              handleTypeChange({ target: { value: "1" } });
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <BlackWhite sx={{ fontSize: 32 }} />
              <Typography fontWeight={600}>{t("Upload.BW")}</Typography>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: selectedType === "2" ? 'primary.main' : 'grey.300',
              bgcolor: selectedType === "2" ? 'secondary.main'  : 'background.paper',
              color: selectedType === "2" ? 'white' : 'text.primary',
              borderRadius: 2,
              cursor: 'pointer',
              boxShadow: selectedType === "2" ? 2 : 0,
            
            }}
            onClick={() => {
              setSelectedType("2");
              handleTypeChange({ target: { value: "2" } });
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <Color sx={{ fontSize: 32 }} />
              <Typography fontWeight={600}>{t("Upload.Color")}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Print Status modern card group */}
      <Box sx={{ mb: 2, width: "100%" }}>
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          
          <Typography variant="h6" fontWeight={600}>{t("Upload.PrintStatus")}</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: "space-between" }}>
          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: selectedStatus === "1" ? 'primary.main' : 'grey.300',
              bgcolor: selectedStatus === "1" ? 'secondary.main' : 'background.paper',
              color: selectedStatus === "1" ? 'white' : 'text.primary',
              borderRadius: 2,
              cursor: 'pointer',
              boxShadow: selectedStatus === "1" ? 2 : 0,
             
            }}
            onClick={() => {
              setSelectedStatus("1");
              handleStatusChange({ target: { value: "1" } });
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <OneSide color={selectedStatus === "1" ? "primary" : "black"} sx={{ fontSize: 32 }} />
              <Typography fontWeight={600}>{t("Upload.Printoneside")}</Typography>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: selectedStatus === "2" ? 'primary.main' : 'grey.300',
              bgcolor: selectedStatus === "2" ? 'secondary.main' : 'background.paper',
              color: selectedStatus === "2" ? 'white' : 'text.primary',
              borderRadius: 2,
              cursor: 'pointer',
              boxShadow: selectedStatus === "2" ? 2 : 0,
            
            }}
            onClick={() => {
              setSelectedStatus("2");
              handleStatusChange({ target: { value: "2" } });
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <TwoSide color={selectedStatus === "2" ? "primary" : "black"} sx={{ fontSize: 32 }} />
              <Typography fontWeight={600}>{t("Upload.Printtwoside")}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <StepNavigation
        onBack={() => !settingsSaved && dispatch(prevStep())}
        onContinue={handleSubmit(onSubmit)}
        backLabel={t("Upload.Back")}
        continueLabel={t("Upload.Continue")}
        showBack={true}
        showContinue={true}
        continueDisabled={!selectedStatus || !selectedType}
        backDisabled={settingsSaved}
      />
    </Box>
  );
}

export default Setting;
